import React from "react";
import { Eye } from "lucide-react";
import { INSPECTOR_CHROME_SECTION_ICON_CLASS } from "../../utils/inspectorChromeButtonClasses";
import Tooltip from "./Tooltip";

/**
 * Eye toggle next to an inspector "Visibility" section title — mirrors Viewer Controls visibility.
 */
export function InspectorVisibilityEyeButton({
  visible,
  onToggle,
  tooltipWhenOn,
  tooltipWhenOff,
  ariaLabel = "Toggle visibility",
  Icon = Eye,
}) {
  const tooltipContent = visible ? tooltipWhenOn : tooltipWhenOff;
  return (
    <Tooltip content={tooltipContent}>
      <button
        type="button"
        aria-label={ariaLabel}
        aria-pressed={visible}
        className={INSPECTOR_CHROME_SECTION_ICON_CLASS}
        style={{
          backgroundColor: "transparent",
          opacity: visible ? 1 : 0.55,
        }}
        onClick={onToggle}
      >
        <div className="relative h-4 w-4">
          <Icon className="h-4 w-4" />
          {!visible && (
            <svg
              className="absolute inset-0 h-4 w-4"
              viewBox="0 0 16 16"
              style={{ pointerEvents: "none" }}
              aria-hidden
            >
              <line
                x1="0"
                y1="14"
                x2="14"
                y2="0"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          )}
        </div>
      </button>
    </Tooltip>
  );
}
